module.exports = __webpack_public_path__ + "static/media/train.4296665c.jpg";